import './party-logo.css';
import { useState } from 'react';

const partyLogoAssets: Record<string, string> = {
  AGIR: 'AGIR/agir.svg',
  AVANTE: 'AVANTE/avante.svg',
  CIDADANIA: 'CIDADANIA/cidadania.svg',
  DEM: 'DEMOCRATAS/democratas.svg',
  MDB: 'MDB/mdb.svg',
  MISSAO: 'MISSAO/missao.svg',
  MOBILIZA: 'MOBILIZA/mobiliza.svg',
  NOVO: 'NOVO/novo.svg',
  PCB: 'PCB/pcb.svg',
  PCDOB: 'PCDOB/PCdoB.svg',
  PCO: 'PCO/pco.svg',
  PDT: 'PDT/pdt.svg',
  PL: 'PL/pl.svg',
  PODEMOS: 'PODEMOS/podemos.svg',
  PP: 'PP/pp.svg',
  PRD: 'PRD/prd.svg',
  PRTB: 'PRTB/prtb.svg',
  PSB: 'PSB/psb.svg',
  PSD: 'PSD/psd.svg',
  PSDB: 'PSDB/psdb_typo.svg',
  PSOL: 'PSOL/PSOL.svg',
  PSTU: 'PSTU/PSTU.svg',
  PT: 'PT/pt.svg',
  PV: 'PV/pv.svg',
  REDE: 'REDE/rede.svg',
  REPUBLICANOS: 'REPUBLICANOS/republicanos.svg',
  SOLIDARIEDADE: 'SOLIEDARIEDADE/soliedariedade.svg',
  UNIAO: 'UNIAO/uniao.svg',
  UP: 'UP/up.svg',
};

function normalizeParty(value: string) {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/gi, '').toUpperCase();
}

export function PartyLogo({ abbreviation, size = 'directory', decorative = false, showFallback = true }: {
  abbreviation: string;
  size?: 'directory' | 'affiliation';
  decorative?: boolean;
  showFallback?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  const label = abbreviation.trim() || 'Partido';
  const key = normalizeParty(label);
  const asset = partyLogoAssets[key] ?? (key === 'PODE' ? partyLogoAssets.PODEMOS : undefined);
  if (!asset && !showFallback) return null;

  return <span className={`party-logo party-logo-${size}`} aria-hidden={decorative || undefined}>
    {asset && !failed
      ? <img src={`/imagem_partidos/${asset}`} alt={decorative ? '' : `Logo do partido ${label}`} loading="lazy" decoding="async" onError={() => setFailed(true)} />
      : showFallback ? <span className="party-logo-fallback" aria-hidden="true">{label.slice(0, 5)}</span> : null}
  </span>;
}
